<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="middleName" id="middleName" type="text" pInputText>
            <label for="middleName">Middle Name</label>
            @for (validation of validationMessages.middleName; track validation) {
              <span>
                @if (form1.get('middleName').hasError(validation.type) && (form1.get('middleName').dirty || form1.get('middleName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="suffixes" formControlName="suffix" optionLabel="name" optionValue="value"
            placeholder="Select Suffix"></p-dropdown>
            <label for="Select Suffix">Select Suffix</label>
            @for (validation of validationMessages.suffix; track validation) {
              <span>
                @if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (personId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete Person</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!personId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add Person</button>
              }

              @if (personId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Person</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>


    @if (personId) {
      <app-person-address-list [personId]="personId"></app-person-address-list>
    }
    @if (personId) {
      <app-person-email-list [personId]="personId"></app-person-email-list>
    }
    @if (personId) {
      <app-person-phone-list [personId]="personId"></app-person-phone-list>
    }
    @if (personId) {
      <app-person-social-list [personId]="personId"></app-person-social-list>
    }